import { useState, useEffect } from 'react';
import { Bitcoin, Save } from 'lucide-react';
import ModuleContainer from '../layout/ModuleContainer.jsx';

export default function DCATargetsSection() {
  const [assets, setAssets] = useState([]);
  const [edits, setEdits] = useState({});
  const [saving, setSaving] = useState({});

  async function load() {
    try {
      const r = await fetch('/api/crypto/assets?tier=dca_target');
      if (r.ok) setAssets(await r.json());
    } catch {}
  }
  useEffect(() => { load(); }, []);

  function setField(symbol, field, value) {
    setEdits(e => ({ ...e, [symbol]: { ...(e[symbol] || {}), [field]: value } }));
  }

  async function save(asset) {
    setSaving(s => ({ ...s, [asset.symbol]: true }));
    const edit = edits[asset.symbol] || {};
    const target_price = edit.target_price !== undefined ? (edit.target_price ? parseFloat(edit.target_price) : null) : asset.dca_target_price;
    const note = edit.note !== undefined ? edit.note : asset.dca_target_note;
    await fetch(`/api/crypto/assets/${asset.symbol}/dca-target`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ target_price, note }),
    });
    setEdits(e => ({ ...e, [asset.symbol]: undefined }));
    setSaving(s => ({ ...s, [asset.symbol]: false }));
    load();
  }

  return (
    <ModuleContainer
      title={<span className="flex items-center gap-2"><Bitcoin className="w-4 h-4 text-orange-400" /> Crypto DCA Targets</span>}
      subtitle="Set accumulation prices for core crypto holdings"
    >
      {assets.length === 0 ? (
        <p className="text-[10px] text-korinth-muted font-mono text-center py-3">
          No DCA assets yet. Run: <code className="text-korinth-accent">node backend/scripts/sprint18_seed_crypto_assets.js --apply</code>
        </p>
      ) : (
        <div className="space-y-1.5">
          {assets.map(a => {
            const edit = edits[a.symbol] || {};
            const currentPrice = a.latest?.price_usd;
            const target = edit.target_price !== undefined ? edit.target_price : a.dca_target_price;
            const hasChanges = edit.target_price !== undefined || edit.note !== undefined;
            return (
              <div key={a.symbol} className="grid grid-cols-1 md:grid-cols-[auto,auto,1fr,2fr,auto] gap-2 items-center px-3 py-2 bg-korinth-bg rounded">
                <span className="text-xs font-mono font-bold text-white w-14">{a.symbol}</span>
                <span className="text-[10px] text-korinth-muted w-16">
                  {currentPrice ? `$${currentPrice < 1 ? currentPrice.toFixed(4) : currentPrice.toLocaleString(undefined, { maximumFractionDigits: 2 })}` : '—'}
                </span>
                <input
                  type="number" step="any" placeholder="target"
                  value={target || ''}
                  onChange={e => setField(a.symbol, 'target_price', e.target.value)}
                  className="bg-korinth-surface border border-korinth-border rounded px-2 py-1 text-xs font-mono text-white w-full"
                />
                <input
                  type="text" placeholder="note (optional)"
                  value={edit.note !== undefined ? edit.note : (a.dca_target_note || '')}
                  onChange={e => setField(a.symbol, 'note', e.target.value)}
                  className="bg-korinth-surface border border-korinth-border rounded px-2 py-1 text-[10px] font-mono text-white w-full"
                />
                <button
                  onClick={() => save(a)}
                  disabled={!hasChanges || saving[a.symbol]}
                  className="flex items-center gap-1 text-[10px] font-mono px-2 py-1 rounded bg-korinth-accent/10 text-korinth-accent border border-korinth-accent/30 disabled:opacity-40 disabled:cursor-not-allowed hover:bg-korinth-accent/20"
                >
                  <Save className="w-3 h-3" /> {saving[a.symbol] ? '...' : 'Save'}
                </button>
              </div>
            );
          })}
        </div>
      )}
    </ModuleContainer>
  );
}
